import { Icon } from '@fluentui/react';
import { useInjectedService } from '../../../services/ioc/service-dependency';
import './app-store-link.css';

interface AppStoreLinkProps {
    link: string;
    ios: boolean;
    comingSoon?: boolean;
    moreText?: string;
}

const AppStoreLink = (props: AppStoreLinkProps) => {

    const { localizationService } = useInjectedService();

    if (props.comingSoon) {
        return <div className={"bbraun-app-store-link-coming-soon"} >
            <div className="bbraun-app-store-link">
                <div className="bbraun-app-store-link-green" />
                <div className="bbraun-app-store-link-container" >
                    {!props.ios && props.moreText === undefined && <img alt={localizationService.getLocalizedText("GooglePlay")} src={require("../../../assets/images/GooglePlay.png")} />}
                    {props.ios && props.moreText === undefined && <img alt={localizationService.getLocalizedText("AppStore")} src={require("../../../assets/images/IOSAppStore.png")} />}
                    {props.moreText !== undefined ?
                        <div className="bbraun-app-store-link-title bbraun-app-store-link-more-text">
                            {props.moreText}
                        </div>
                        :
                        <div className="bbraun-app-store-link-title">
                            {localizationService.getLocalizedText("ComingSoon")}
                        </div>
                    }
                </div>
            </div>
        </div>;
    }

    return <a className={"bbraun-app-store-link-a"} href={props.link}>
        <div className="bbraun-app-store-link">
            <div className="bbraun-app-store-link-green" />
            <div className="bbraun-app-store-link-container" >
                {!props.ios && props.moreText === undefined && <img alt={localizationService.getLocalizedText("GooglePlay")} src={require("../../../assets/images/GooglePlay.png")} />}
                {props.ios && props.moreText === undefined && <img alt={localizationService.getLocalizedText("AppStore")} src={require("../../../assets/images/IOSAppStore.png")} />}
                {props.moreText !== undefined &&
                    <Icon className="bbraun-app-store-link-more-icon" iconName="Info" />
                }
                {props.moreText === undefined ?
                    <div className="bbraun-app-store-link-title">
                        {!props.ios ? localizationService.getLocalizedText("GooglePlay") : localizationService.getLocalizedText("AppStore")}
                    </div>
                    :
                    <div className="bbraun-app-store-link-title bbraun-app-store-link-more-text">
                        {props.moreText}
                    </div>
                }
            </div>
        </div>
    </a>;
}

export default AppStoreLink;
